<template>
  <div class="min-h-screen bg-linear-to-r from-green-600 to-green-400 text-white">

    <!-- Hero -->
    <div class="flex flex-col items-center text-center py-30 px-6 bg-cover bg-center"
      :style="{ backgroundImage: `url(${require('@/assets/img/fondoNegocio.jpg')})` }">
      <!-- Overlay oscuro para legibilidad -->

      <h1 class="text-5xl font-extrabold animate__animated animate__fadeInBottomLeft">
        Publicidad Efectiva = <span class="text-yellow-400">Más Clientes, Más Ventas</span>
      </h1>
      <p class="mt-8 text-lg max-w-3xl animate__animated animate__zoomInLeft">
        El <span class=" text-yellow-400 font-extrabold">80%</span> de los negocios gastan en publicidad sin ver
        resultados.
        En <span class=" text-yellow-400 font-extrabold">Virtual Shopping Club</span> tu negocio llega directamente a
        compradores interesados.
      </p>
      <router-link :to="registroRoute" class="mt-6 px-8 py-4 bg-white text-green-700 font-bold rounded-full shadow-xl hover:bg-gray-200
                            transition transform hover:scale-110">
        ¡Únete y haz crecer tus ventas!
      </router-link>
    </div>

    <!-- Video Explicativo -->
    <div class="bg-gray-50 text-center pt-12">
      <!-- Video de YouTube -->
      <div class="mx-auto max-w-4xl px-6 lg:px-8">
        <div class="aspect-w-16 aspect-h-9">
          <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
            src="https://www.youtube.com/embed/M4o5Zc7c3fQ" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>

    <!-- Ciudades con vida digna -->
    <section class="bg-gray-50 text-gray-700 py-16 px-4 md:px-16 animate-fade-in">
      <div class="max-w-6xl mx-auto text-center">
        <h2 class="text-4xl text-green-700 md:text-5xl font-bold mb-6 animate-slide-in-down">
          Aprovecha la iniciativa "Ciudades con Vida Digna"
        </h2>
        <p class="text-xl md:text-2xl  font-medium mb-12 animate-fade-in delay-200">
          <span class="text-green-700">Yatvii S de R.L.</span> empresa socialmente responsable a iniciado una
          <span class="text-green-700">inversión histórica</span>
          para transformar
          miles de negocios
          con la campaña de cupones de descuentos para el fortalecimiento, tecnificacion del comercio local y
          el empoderamiento del consumidor.
        </p>

        <h1 class="text-3xl text-green-700 font-bold mb-2">A Nivel Nacional</h1>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 animate-slide-in-up">
          <div data-aos="fade-up" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-yellow-400">
            <p class="text-4xl font-bold text-yellow-400">245</p>
            <p class="text-lg">📍 Zonas en todo México</p>
          </div>
          <div data-aos="fade-up" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-yellow-400">
            <p class="text-4xl font-bold text-yellow-400">+122,500</p>
            <p class="text-lg">💼 Negocios patrocinados</p>
          </div>
          <div data-aos="fade-up" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-yellow-400">
            <p class="text-4xl font-bold text-yellow-400">$465M - $1.22B</p>
            <p class="text-lg">💰 Inversión total (MXN)</p>
          </div>
        </div>

        <div data-aos="fade-up"
          class="w-full max-w-3xl mx-auto bg-white rounded-xl flex justify-center items-center mb-16">
          <img src="@/assets/img/inversion.jpg" alt="VSC" class="w-full md:w-3/4 h-auto rounded-lg" />
        </div>

        <h1 class="text-3xl text-green-700 font-bold mb-2">A Nivel ciudad o Zona</h1>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16 animate-slide-in-up">
          <div data-aos="fade-up" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-yellow-400">
            <p class="text-4xl font-bold text-yellow-400">500</p>
            <p class="text-lg">💼 Negocios patrocinados aproximadamente</p>
          </div>
          <div data-aos="fade-up" class="bg-white rounded-2xl shadow-lg p-6 border-l-8 border-yellow-400">
            <p class="text-4xl font-bold text-yellow-400">$1.9M a $5M</p>
            <p class="text-lg">💰 De inversión por ciudad</p>
          </div>
        </div>
        <section class="flex items-center justify-center">
          <div class="max-w-4xl w-full rounded-2xl">
            <h2 class="text-3xl font-bold text-green-700 text-center mb-6">
              ¡Aprovecha los Patrocinios que Yatvii tiene para ti!
            </h2>
            <p class="text-xl text-center mb-8">
              En el inicio de la campaña de cupones en tu zona que tiene un valor <span class="font-semibold text-green-700">$10,000
                MXN</span>. Yatvii ofrece patrocinios especiales.
            </p>

            <div class="grid md:grid-cols-2 gap-6">
              <!-- 90% Patrocinio -->
              <div data-aos="fade-up" class="rounded-xl p-6 text-center">
                <h3 class="text-xl font-bold text-green-700">90% Patrocinio</h3>
                <p class="text-lg font-semibold text-gray-800">Aporte del negocio: <span
                    class="text-green-700">$1,000</span></p>
              </div>

              <!-- 50% Patrocinio -->
              <div data-aos="fade-up" class="rounded-xl p-6 text-center">
                <h3 class="text-xl font-bold text-green-700">50% Patrocinio</h3>
                <p class="text-lg font-semibold text-gray-800">Aporte del negocio: <span
                    class="text-green-700">$5,000</span></p>
              </div>
            </div>
            <p class="text-2xl text-green-700 font-medium mb-2 mt-4 animate-fade-in delay-500">
              ¿Qué tienen que hacer los negocios?
            </p>
            <ul class="text-xl mb-12 animate-fade-in delay-500">
              <li>1. Cubrir aportación (Con o Sin patrocinio)</li>
              <li>2. Desear tener $1,000,000 en ventas o en beneficios</li>
              <li>3. Otorgar <strong>descuentos</strong> desde el 10% a miembros del club</li>
            </ul>
          </div>
        </section>


        <div data-aos="zoom-out-up">
          <router-link :to="registroRoute"
            class="boton bg-blue-600 gradient-bg text-white text-xl font-semibold py-4 px-8 rounded-full shadow-lg">
            ✨ Quiero Mas Infomacion
          </router-link>
        </div>

      </div>
    </section>

    <div class="bg-gradient-to-r from-gray-400 via-green-400 to-gray-400 pt-2 pb-2">
    </div>


    <!-- Sección de Beneficios -->
    <div class="pt-12 bg-white">
      <div class="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <h1 class="text-4xl text-green-700 font-semibold">¡Únete al <span class="font-bold text-yellow-500">Club de
            Negocios</span> y lleva tu empresa al siguiente
          nivel</h1>
        <p class="text-lg md:text-xl text-gray-700  p-4 rounded-xl ">
          Al formar parte del <strong class="text-yellow-500">Club de Negocios</strong>
          tu negocio accederá a ventas efectivas, publicidad permanente y la posibilidad de generar ingresos extras de
          forma constante. <br><br>
          Y eso no es todo: si estás entre los primeros 100 negocios en unirse, recibirás el reconocimiento especial
          como <span class=" font-bold text-yellow-500">Miembro Fundador del Club</span>, lo que te brindará ventajas
          exclusivas y prioridad en futuras oportunidades.
        </p>
      </div>
    </div>

    <!-- Sección de Beneficios -->
    <div class="pt-12 pb-12 bg-white text-gray-800 px-6">
      <h2 class="text-center text-4xl font-bold text-green-700">💡 Beneficios Exclusivos</h2>
      <div class="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">

        <div
          class="flex flex-col items-center p-6 bg-gray-200 rounded-lg shadow-lg shadow-green-500 transition hover:shadow-xl">
          <img src="@/assets/img/publicidad.png" alt="Icono de publicidad" class="w-17 h-16 mx-auto mb-4">
          <h3 class="text-xl font-semibold mt-4">Publicidad Efectiva</h3>
          <p class="mt-2 text-center">Pon tu negocio frente a millas de clientes dentro de Virtual Shopping Club. ¡Que
            te vean y te elijan!.</p>
        </div>

        <div
          class="flex flex-col items-center p-6 bg-gray-200 rounded-lg shadow-lg shadow-green-500 transition hover:shadow-xl">
          <img src="@/assets/img/VentasEfect.png" alt="Icono depublicidad" class="w-17 h-16 mx-auto mb-4">
          <h3 class="text-xl font-semibold mt-4">Más clientes, más ventas </h3>
          <p class="mt-2 text-center">Conéctate con compradores listos para comprar y aumenta tus ingresos sin esfuerzo.
          </p>
        </div>
      </div>

      <div class="mt-10 grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
        <div
          class="flex flex-col items-center p-6 bg-gray-200 rounded-lg shadow-lg shadow-green-500 transition hover:shadow-xl">
          <img src="@/assets/img/ingresosExt.png" alt="Icono de publicidad" class="w-16 h-16 mx-auto mb-4">
          <h3 class="text-xl text-center font-semibold mt-4">Gana más</h3>
          <p class="mt-2 text-center">Además de tus ventas, recibe bonos extra con una herramienta exclusiva para
            negocios.</p>
        </div>

        <div
          class="flex flex-col items-center p-6 bg-gray-200 rounded-lg shadow-lg shadow-green-500 transition hover:shadow-xl">
          <img src="@/assets/img/comunidad.png" alt="Icono de publicidad" class="w-17 h-16 mx-auto mb-4">
          <h3 class="text-xl text-center font-semibold mt-4">Únete al Club de Negocios Afiliados</h3>
          <p class="mt-2 text-center">Sé parte de una comunidad que impulsa el comercio local y premia a quienes confían
            en ella. </p>
        </div>

        <div
          class="flex flex-col items-center p-6 bg-gray-200 rounded-lg shadow-lg shadow-green-500 transition hover:shadow-xl">
          <img src="@/assets/img/proveedor.png" alt="Icono de publicidad" class="w-17 h-16 mx-auto mb-4">
          <h3 class="text-xl text-center font-semibold mt-4">Proveedor de la Comunidad VSC</h3>
          <p class="mt-2 text-center">Además de tus ventas, recibe bonos extra con una herramienta exclusiva para
            negocios.</p>
        </div>

        <div
          class="flex flex-col items-center p-6 bg-gray-200 rounded-lg shadow-lg shadow-green-500 transition hover:shadow-xl">
          <img src="@/assets/img/F3.png" alt="Icono de publicidad" class="w-16 h-16 mx-auto mb-4">
          <h3 class="text-xl text-center font-semibold mt-4">¡Oferta especial!</h3>
          <p class="mt-2 text-center">Los primeros 100 negocios en afiliarse en tu zona reciben una recompensa
            exclusiva.</p>
        </div>

      </div>
    </div>

    <!-- Sección de Oferta Especial f3 -->
    <div class="bg-gradient-to-r from-green-600 to-green-400 py-16 px-6">
      <div class="flex flex-col md:flex-row items-center max-w-6xl mx-auto">

        <!-- Imagen (Encima en móviles, a la derecha en pantallas grandes) -->
        <div class="w-full md:w-1/4 flex justify-center mb-6 md:mb-0">
          <img src="@/assets/img/cardVSC.png" alt="Icono de publicidad" class="w-75 h-54">
        </div>

        <!-- Contenido (75% en pantallas grandes) -->
        <div class="w-full md:w-3/4 text-white md:pr-6 text-center md:text-left">
          <h3 class="text-3xl font-bold">¡Promoción especial para los primeros 100 negocios de la zona!</h3>
          <p class="mt-2 text-lg text-justify">
            Si eres de los primeros 100 comercios en unirte al Club de Negocios Afiliados por medio de tu membresía,
            recibirás sin costo el acceso al
            <span class="font-bold text-yellow-400">Programa F3</span> (valorado en $10,000 MXN),
            una herramienta diseñada para multiplicar tus ingresos. Con ella, ganarás bonos mensuales basados ​​en las
            <b>ventas y cupones</b> aplicados en los negocios
            afiliados en tu zona participante. <br><br>
            ¡Es como recibir una renta mensual sin esfuerzo!
          </p>
        </div>
      </div>

      <!-- Botón de llamada a la acción -->
      <div class="mt-6 text-center">
        <router-link :to="registroRoute"
          class="px-8 py-4 bg-white text-green-700 font-bold rounded-full hover:bg-yellow-400 hover:text-white">
          ¡Quiero ser uno de los 100!
        </router-link>
      </div>
    </div>

    <!-- Sección de Tecnologia -->
    <div class="py-16 bg-white">
      <h2 class="text-4xl font-serif font-bold text-center text-green-600 mb-12">
        En Virtual Shopping Club obtienes acceso a <span class="text-yellow-400 font-bold">3 tecnologías
          exclusivas</span> que impulsarán tu negocio:
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto px-6 lg:px-12">
        <div class="bg-white border border-green-400 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-green-600">🎟️ Campaña de cupones</h3>
          <p class="mt-2 text-gray-600">
            Con nuestras campañas tendrás una forma muy efectiva de atraer nuevos clientes, dar a conocer tu
            negocio y potencializar tus ventas efectivas.
          </p>
        </div>

        <div class="bg-white border border-green-400 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-green-600">🏆 Centro de canje de puntos</h3>
          <p class="mt-2 text-gray-600">
            Al ser tu negocio un centro de canje de puntos vas a obtener clientes fieles, tecnificación de
            tu negocio y ventaja competitiva con negocios externos.
          </p>
        </div>

        <div class="bg-white border border-green-400 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-green-600">🤝 Patrocinador F3</h3>
          <p class="mt-2 text-gray-600">
            Una tecnología solo para <span class="font-semibold text-green-600">miembros fundadores</span>
            con la cual podras recibir ingresos pasivos por las ventas y cupones aplicados en la zona de tu
            ciudad de residencia.
          </p>
        </div>
      </div>
    </div>

    <!-- Programa de Ingresos Extras -->
    <div class="py-16 mt-12 text-white text-center">
      <h2 class="text-4xl font-serif font-bold">💸 Tus ventas no tienen que ser tu única <span
          class="text-yellow-400">fuente de ingresos.</span></h2>
      <p class="mt-6 max-w-4xl mx-auto text-lg px-2">
        Con el <span class="text-yellow-400 font-bold">Programa Fusión</span>, tu negocio desbloquea una nueva fuente de
        ingresos diseñada para
        brindarte <b>publicidad permanente</b>, <b>tecnificación de tu negocio</b> y un <b>flujo de ganancias que
          puede ir desde pequeños ingresos hasta cifras ilimitadas</b>.
        <br><br>
        Todo comienza al conectar personas y negocios a Virtual Shopping Club. Cuanto más compartes esta
        oportunidad, más crecen tus beneficios y el alcance de tu negocio.
      </p>

      <img src="@/assets/img/ingresosExt.png" alt="Ingresos" class="w-40 mx-auto my-6">
      <router-link :to="registroRoute"
        class="px-8 py-4 bg-white text-green-600 font-bold text-lg rounded-full hover:bg-yellow-500 hover:text-white transition">
        ¡Descubre cómo funciona!🔥
      </router-link>
    </div>


    <!-- Sección de Testimonios -->
    <div class="py-16 px-6 bg-gray-100">
      <h3 class="text-center text-4xl font-bold text-green-700">📢 Lo Que Dicen Nuestros Socios</h3>
      <div class="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">

        <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col">
          <p class="italic text-lg text-gray-800">"Desde que me uní a Virtual Shopping Club, mis ventas han aumentado y
            mis ingresos pasivos han crecido mes a mes."</p>
          <p class="mt-2 font-semibold text-right text-green-700">— Dr. Ortega, Consultorio Vida Nueva y Nutrición</p>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col">
          <p class="italic text-lg text-gray-800">"Ser parte de este club ha sido un cambio radical en mi negocio. ¡Muy
            recomendado!"</p>
          <p class="mt-2 font-semibold text-right text-green-700">— Comercializadora del ahorro OP</p>
        </div>

      </div>
    </div>

    <div class="bg-gradient-to-r from-gray-400 via-green-400 to-gray-400 pt-2 pb-2">
    </div>

    <!-- Sección de Preguntas Frecuentes -->
    <div class="py-16 px-6 text-center bg-white text-gray-800">
      <h3 class="text-3xl font-bold text-green-700">❓ Preguntas Frecuentes</h3>
      <details class="mt-6 bg-gray-100 p-4 rounded-lg shadow-md">
        <summary class="font-semibold text-lg cursor-pointer"> ¿Qué necesito para unirme al club?</summary>
        <p class="mt-2">Solo necesitas tener un negocio físico, una actitud amable y de servicio, ¡y listo!
          obtén tu membresía y empieza a disfrutar de los beneficios.</p>
      </details>
      <details class="mt-6 bg-gray-100 p-4 rounded-lg shadow-md">
        <summary class="font-semibold text-lg cursor-pointer"> ¿Qué negocios pueden participar?</summary>
        <p class="mt-2">¡Cualquiera! No importa si vendes un producto o prestas un servicio, puedes unirte al
          club.
          Lo único que necesitas es que tu negocio sea legal y pueda emitir facturas.</p>
      </details>
      <details class="mt-6 bg-gray-100 p-4 rounded-lg shadow-md">
        <summary class="font-semibold text-lg cursor-pointer"> ¿Dónde se mostrará la publicidad de mi negocio?
        </summary>
        <p class="mt-2"> Si eres uno de los primeros 100 negocios de la zona en unirte, tendrás prioridad para
          aparecer
          en nuestra aplicación. Además, podrás tener la oportunidad de figurar en presentaciones virtuales,
          campañas publicitarias o material promocional.</p>
      </details>
      <details class="mt-6 bg-gray-100 p-4 rounded-lg shadow-md">
        <summary class="font-semibold text-lg cursor-pointer"> No sé mucho de marketing, ¿es necesario para
          unirme al club?</summary>
        <p class="mt-2"> ¡Para nada! No importa si eres experto en marketing o no. Aquí trabajarás con un
          experto que te ayudará con las ventas, publicidad y hacer crecer tus contactos.</p>
      </details>
    </div>

    <!-- CTA Final -->
    <div class="bg-gradient-to-r from-green-600 to-green-400 text-center py-12">
      <h2 class="text-3xl text-white font-extrabold text-white">
        ¡Únete Hoy y Lleva Tu Negocio Al Siguiente Nivel!
      </h2>
      <img src="@/assets/img/vsc.png" alt="publicidad" class="w-40 h-30 mx-auto mt-4">
      <p class="text-lg text-blue-100 mt-6 mb-8">
        Regístrate y comienza a disfrutar de todos los beneficios exclusivos para miembros del Club de
        Negocios.
      </p>
      <router-link :to="registroRoute" class="mt-4 px-8 py-4 bg-white text-green-700 font-bold rounded-full hover:bg-yellow-400
                            hover:text-white transition ">
        Unirme Ahora
      </router-link>
    </div>

    <patrocinadores-comp :patrocinadores="patrocinadores" v-if="patrocinadores.length > 0"></patrocinadores-comp>
  </div>
</template>

<script>
import patrocinadoresComp from "@/components/campanias/patrocinadores"

export default {
  name: 'ClubNegocios3',
  components: {
    patrocinadoresComp
  },
  props: {
    patrocinadores: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    registroRoute() {
      return typeof this.$route.params.codigo !== 'undefined' ? `/registro/campania/${this.$route.params.codigo}` :
        '/registro'
    }
  },
  mounted() {
    fbq('init', '1351295932570313')
    fbq('track', 'PageView')
  }
}
</script>
<style scoped>
@media (max-width: 568px) {
  .boton {
    text-anchor: end;
  }
}

.gradient-bg {
  background: linear-gradient(45deg, #14b925, #37e88f, #14b925, #37e88f);
  background-size: 400% 400%;
  animation: gradientChange 4s ease infinite;
}
</style>